export var localStorageServiceKey;
(function (localStorageServiceKey) {
    localStorageServiceKey["SEARCH_RECENTS"] = "SEARCH_RECENTS";
    localStorageServiceKey["HISTORY"] = "HISTORY";
    localStorageServiceKey["FAVORITE"] = "FAVORITE";
})(localStorageServiceKey || (localStorageServiceKey = {}));
export const localStorageService = {
    get(key) {
        const data = localStorage.getItem(key);
        return data && data.length ? JSON.parse(data) : [];
    },
    set(key, items) {
        localStorage.setItem(key, JSON.stringify(items));
    },
};
